import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';

const Layout = () => {
  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <main className="main-content p-6 lg:p-8" data-testid="main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
